const Title = () => (
    <section id="title">
        <div className="container-fluid pt-4 pb-2 text-center">
            <div className="row align-items-center justify-content-center">
                <div className="col-md-8 col-11">
                    <h3 className="mb-3"><b>WAIT! WE HAVE A SPECIAL ONE-TIME GIFT FOR NEW CUSTOMERS ONLY.</b></h3>
                    <h5 className="fw-light">⚠️ Do not refresh or close this page – this exclusive gift will not appear again.</h5>
                </div>
            </div>
        </div>
    </section>
);

export default Title;